module.exports = __webpack_public_path__ + "img/pek_33.c6600efd.png";